module.exports = "/images/ingredients-4.png";